import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { ReportsService } from '../reports.service';
import { DialogComponent, DialogModule } from '@syncfusion/ej2-angular-popups';
import { UntypedFormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { ReportFileType, SavedReportFileDTO } from '../../../base/models/models.swagger.generated';
import { Router } from '@angular/router';
import { reportsRoute } from '../../../core/routing/route-names';
import { SaveOptions } from './save-options';
import { TranslateModule } from '@ngx-translate/core';
import { ButtonGroupComponent } from '../../../base/shared/button-group/button-group.component';
import { YesNoGroupButtonComponent } from '../../../base/shared/yes-no-group-button/yes-no-group-button.component';
import { DownloadLinkUtil } from '../download-link.util';

@Component({
    selector: 'app-reports-footer',
    templateUrl: './reports-footer.component.html',
    styleUrls: ['./reports-footer.component.scss'],
    imports: [DialogModule, ReactiveFormsModule, YesNoGroupButtonComponent, ButtonGroupComponent, TranslateModule]
})
export class ReportsFooterComponent implements OnInit {

  @ViewChild('saveDialog') public saveDialog: DialogComponent;
  @Output() public saveClicked = new EventEmitter<SaveOptions>();

  @Input() public set hideFileTypeSelector(value: boolean) {
    if (this._hideFileTypeSelector === value) {
      return;
    }
    this._hideFileTypeSelector = value;
    if (this._hideFileTypeSelector) {
      this.saveForm.get('exportType').setValidators([]);
    } else {
      this.saveForm.get('exportType').setValidators([Validators.required]);
    }
  }

  public get hideFileTypeSelector(): boolean {
    return this._hideFileTypeSelector;
  }

  public now = new Date();

  public ReportFileType = ReportFileType;

  public saveForm = this.fb.group({
    saveReport: ['', Validators.required],
    exportType: ['', Validators.required],
  });

  private _hideFileTypeSelector = false;

  constructor(private reportsService: ReportsService,
              private router: Router,
              private fb: UntypedFormBuilder) {
  }

  public ngOnInit(): void {
  }

  public cancel(): void {
    this.router.navigate([reportsRoute]);
  }

  public openSaveDialog(): void {
    this.saveDialog.show();
  }

  public saveReport(): void {
    this.saveClicked.emit(this.saveForm.value);
    this.saveDialog.hide();
  }

  public closeSave(): void {
    this.saveDialog.hide();
  }

  public downloadFile(savedReportFileDTO: SavedReportFileDTO): void {
    const link = DownloadLinkUtil.createInvisibleDownloadLink(savedReportFileDTO);
    link.click();
  }
}
